var exports = {
  "Hk": "x61f99309--c306b6--action-buttons",
  "o6": "x61f99309--c306b6--action-buttons__buttons",
  "MK": "x61f99309--c306b6--action-buttons__daily-rent-buttons",
};

module.exports = exports;
